import { Col, Input, Row, Select, Space, Table } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getCategories, getDocuments } from 'services/notice';
import { Link } from 'react-router-dom';

function List({ recent }) {
  const [docs, setDocs] = useState([]);
  const [searchVal, setSearchVal] = useState({ key: 'title', value: '' });
  const [categories, setCategories] = useState([]); // 카테고리 정보
  const [selectedCategory, setSelectedCategory] = useState(null); // 선택된 카테고리
  const [paginationInfo, setPaginationInfo] = useState({
    current: 1,
    pageSize: 10,
    type: 'notice',
  });

  const [reRendering, setRerendering] = useState(true);

  // recent(Desktops 페이지의 공지사항)일 때는 fixed하지 않는다.
  const unfixedWhenRecent = () => (!recent ? 'left' : false);

  const columns = [
    {
      title: '카테고리',
      dataIndex: 'name',
      fixed: unfixedWhenRecent(),
      width: 180,
      ellipsis: true,
    },
    {
      title: '제목',
      dataIndex: 'title',
      ellipsis: true,
      fixed: unfixedWhenRecent(),
      render: (item, record) => (
        <Link
          to={{
            pathname: '/help/notice/view',
            state: { guid: record.guid },
          }}
        >
          {item}
        </Link>
      ),
    },
    {
      title: '게시일',
      dataIndex: 'createDate',
      width: 100,
      render: (text) => moment(text).format('YYYY-MM-DD'),
    },
  ];

  useEffect(() => {
    if (!reRendering) {
      return;
    }

    const params = {
      ..._.pickBy(
        paginationInfo,
        (__, key) => key !== 'data' && key !== 'success' && key !== 'total',
      ),
      type: 'notice',
    };

    if (searchVal.value) {
      params[searchVal.key] = searchVal.value;
    }

    if (selectedCategory) {
      params.categoryId = selectedCategory;
    }

    getDocuments(params).then((documents) => {
      setDocs(documents.data);
      setPaginationInfo(_.pickBy(documents, (__, key) => key !== 'data' && key !== 'success'));
      setRerendering(false);
    });
  }, [reRendering]);

  useEffect(() => {
    getCategories({ type: 'notice' }).then((data) => {
      let result = [];
      result = data.map((item) => ({ label: item.name, value: item.categoryId }));
      setCategories(result);
      setSelectedCategory(null);
    });
  }, []);

  return (
    <Row gutter={[0, 16]}>
      {!recent && (
        <Col span={24}>
          <Space>
            <Select
              size="large"
              style={{ width: 160 }}
              defaultValue={null}
              options={[{ label: '전체', value: null }, ...categories]}
              onChange={(value) => {
                setSelectedCategory(value);
                setRerendering(true);
              }}
            />
            <Input.Group compact style={{ display: 'flex' }}>
              <Select
                size="large"
                defaultValue={searchVal?.key}
                style={{ width: 100 }}
                options={[
                  { label: '제목', value: 'title' },
                  { label: '카테고리', value: 'name' },
                  // { label: '작성자', value: 'register' },
                ]}
                onChange={(value) => {
                  setSearchVal((prev) => ({ ...prev, key: value }));
                }}
              />
              <Input.Search
                size="large"
                allowClear
                placeholder="검색"
                onSearch={(val) => {
                  setSearchVal((prev) => ({ ...prev, value: val }));
                  setRerendering(true);
                }}
              />
            </Input.Group>
          </Space>
        </Col>
      )}
      <Col span={24}>
        <Table
          rowKey="guid"
          size="middle"
          dataSource={recent ? docs.slice(undefined, 5) : docs}
          columns={columns}
          scroll={{ x: 640 }}
          pagination={
            recent
              ? false
              : {
                  ...paginationInfo,
                  onChange: (current, pageSize) => {
                    setPaginationInfo((prev) => ({ ...prev, current, pageSize }));
                    setRerendering(true);
                  },

                  showSizeChanger: true,
                  onShowSizeChange: (current, pageSize) => {
                    setPaginationInfo((prev) => ({ ...prev, current, pageSize }));
                    setRerendering(true);
                  },
                }
          }
        />
      </Col>
    </Row>
  );
}

export default List;
